import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

/* -------- packages -------- */
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
//import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
/* -------- ------- -------- */

/* -------- components -------- */
import {avatarImages} from "../../../utils/items";
import Loading from "../Loading";
import { useSelector } from "react-redux";
import { getProfileImage } from "../../../utils/userTools";
/* -------- ------- -------- */


export default function ProfileMenu () {

  const { t } = useTranslation();
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const parameters = useSelector(state => state.Parameters);
  const user = useSelector(state => state.Login.user);
  
  const [imgSrc, setImgSrc] = useState(parameters.logoIcon);
  const userPref = user && typeof user.prefs === 'object' ? user.prefs : JSON.parse(user.prefs);

/* ------------------- profile image ------------------- */
  useEffect(() => {
    setImgSrc(getProfileImage(userPref, parameters.logoIcon)); // Suppose que les images sont nommées avatar_1.jpg, avatar_2.jpg, etc.
  }, [userPref]);

/* ------------------- ------------- ------------------- */



  return (
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block profileMenuDownDown"
        id="projProfileDropdown"
      >
        <DropdownToggle
          className="btn header-item "
          id="pageHeaderUserDropdown"
          tag="button"
        >
        {(imgSrc) ?
          <img
            className="rounded-circle header-profile-user"
            src={imgSrc}
            alt="Avatar"/>
          :
          <Loading type={"small"} />
          }
          <span className="d-none d-xl-inline-block ms-2 me-1">{user?.fullName}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link id="projProfileLink" className="dropdown-item" to="/profile">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {t("profile")}{" "}
          </Link>
          <div className="dropdown-divider" />
          <Link to="/logout" id="projLogoutLink" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{t("logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
  );
};
